import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { globalData } from 'global/js/globalData';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import './ThankYou.scss';

class ThankYou extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const thankYouText = this.props.surveyData.ThankYouText;
        const isBackupSurvey = this.props.surveyData.IsBackup || false;

        return (
            <section className='wrapper thank-you'>
                {this.props.surveyData.IsBackup && (
                    <Header 
                        customerData={this.props.surveyData.Evaluator} 
                        isOverall={true} 
                    />
                )}

                <div className='container'>
                    <div className='content'>
                        <img 
                            alt='checkmark icon for completeness' 
                            className='thank-you__icon' 
                            src='../build/media/complete-icon.svg' 
                        />

                        <h1 className='thank-you__heading'>
                            {globalData.thankYouMessage}
                        </h1>

                        <div 
                            className='thank-you__message'
                            dangerouslySetInnerHTML={{ __html: thankYouText }}
                        />
                    </div>

                    {!isBackupSurvey && (
                        <Link className='thank-you__button' to={'/'}>
                            {globalData.returnButtonText}
                        </Link>
                    )}
                </div>

                <img 
                    alt="Education First Logo" 
                    className="thank-you__logo"
                    src="../build/media/EF-notag-white.svg" 
                />
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThankYou));



// WEBPACK FOOTER //
// ./application/containers/ThankYou/ThankYou.jsx